import React from "react";
import { connect } from "react-redux";
import {
  Transition,
  Container,
  Header,
  Segment,
  Button,
  Menu
} from "semantic-ui-react";
import { confirmadasOps, confirmadasSelectores } from "../../ducks/confirmadas";
import isEmpty from "lodash/isEmpty";
import Tabla from "./listaInscripciones/Tabla";
import NewWindowAsis from "./listaInscripciones/NewWindowAsis";
import TablaAsistencias from "./listaInscripciones/TablaAsistencias";
import ModalFiltros from "./listaInscripciones/ModalFiltros";
import ModalConfirm from "../shared/ModalConfirm";

class ListaInscripciones extends React.Component {
  state = {
    visible: false,
    showPortal: false,
    openModalFiltros: false,
    showModalConfirm: false
  };

  componentDidMount() {
    const { match: { params } } = this.props;
    this.props.obtenerDatosColegio(params.idColegio);
    this.props.obtenerInscripcionesDelColegio(params.idColegio);
    this.setState(state => ({ visible: true }));
  }

  componentWillReceiveProps({ dataSaved }, nextContext) {
    const { match: { params: { idColegio } } } = this.props;
    dataSaved.status && this.props.obtenerInscripcionesDelColegio(idColegio);
    dataSaved.status && setTimeout(() => this.props.resetSavedData(), 1000);
  }

  componentWillUnmount() {
    this.props.limpiarInscripcionesDelColegio();
    this.props.resetFiltros();
    this.setState(state => ({ visible: false }));
  }

  toggleShowPortal = () =>
    this.setState(state => ({ showPortal: !state.showPortal }));

  filtrarDatos = () => this.setState(state => ({ openModalFiltros: true }));

  handleCerrar = () => this.props.history.push("/inscripciones-confirmadas");

  handleIrAInicio = () => this.props.history.push("/");

  handleModalCancel = () =>
    this.setState(state => ({
      openModalFiltros: false,
      showModalConfirm: false
    }));

  handleModalAplicarFiltros = filtros =>
    this.setState(
      (state, filtros) => ({ openModalFiltros: false }),
      () => this.props.aplicarFiltros(filtros)
    );

  handleModalEliminarFiltros = () =>
    this.setState(
      state => ({ openModalFiltros: false }),
      () => this.props.resetFiltros()
    );

  handleClickFormaDePago = idInscripcion =>
    this.setState(state => ({ showModalConfirm: true, idInscripcion }));

  handleFormaDePago = ({ idInscripcion, formaDePago }) => {
    this.setState({ showModalConfirm: false });
    this.props.cambiarFormaDePago({
      idColegio: this.props.match.params.idColegio,
      idInscripcion,
      formaDePago
    });
  };

  handleClickItemTable = () => this.props.limpiarDatosColegio();

  handleBorrarLinea = ({ idInscripcion }) =>
    this.props.borrarInscripcion({
      idColegio: this.props.match.params.idColegio,
      idInscripcion
    });

  render() {
    const { datosColegio } = this.props;
    return (
      <Transition.Group animation="scale" duration={250}>
        {this.state.visible &&
          !isEmpty(datosColegio) && (
            <Container>
              <Segment basic>
                <Menu>
                  <Menu.Item
                    as={Button}
                    icon="print"
                    content="Control de Asistencia"
                    onClick={this.toggleShowPortal}
                  />
                  <Menu.Item
                    as={Button}
                    icon="filter"
                    content="Filtrar"
                    onClick={this.filtrarDatos}
                  />
                  <Menu.Menu position="right">
                    <Menu.Item
                      as={Button}
                      icon="home"
                      content="Ir a Inicio"
                      onClick={this.handleIrAInicio}
                    />
                    <Menu.Item
                      as={Button}
                      icon="close"
                      content="Cerrar"
                      onClick={this.handleCerrar}
                    />
                  </Menu.Menu>
                </Menu>
                <Header
                  inverted
                  as="h2"
                  content={`Inscripciones Confirmadas de ${
                    datosColegio.nombre
                  }`}
                  textAlign="center"
                />
              </Segment>
              <Tabla
                datos={this.props.datos}
                idColegio={datosColegio.idColegio}
                filtros={this.props.filtrosAplicados}
                handleBorrarLinea={this.handleBorrarLinea}
                handleClickFormaDePago={this.handleClickFormaDePago}
                handleClickItem={this.handleClickItemTable}
              />
              {this.state.showPortal && (
                <NewWindowAsis>
                  <TablaAsistencias
                    colegio={datosColegio}
                    datos={this.props.datos}
                    filtros={this.props.filtrosAplicados}
                  />
                </NewWindowAsis>
              )}

              <ModalConfirm
                open={this.state.showModalConfirm}
                idInscripcion={this.state.idInscripcion}
                handleCancelarModal={this.handleModalCancel}
                handleFormaDePago={this.handleFormaDePago}
              />

              <ModalFiltros
                open={this.state.openModalFiltros}
                handleCancelarModal={this.handleModalCancel}
                handleAplicarFiltros={this.handleModalAplicarFiltros}
                handleEliminarFiltros={this.handleModalEliminarFiltros}
              />
            </Container>
          )}
      </Transition.Group>
    );
  }
}

const mapStateToProps = state => ({
  datosColegio: state.confirmadas.datosColegio,
  datos: confirmadasSelectores.getDatosFiltrados(state),
  filtrosAplicados: state.confirmadas.filtrosAplicados,
  dataSaved: state.confirmadas.dataSaved
});

const mapDispatchToProps = {
  obtenerInscripcionesDelColegio: confirmadasOps.obtenerInscripcionesDelColegio,
  limpiarInscripcionesDelColegio: confirmadasOps.limpiarInscripcionesDelColegio,
  obtenerDatosColegio: confirmadasOps.obtenerDatosColegio,
  limpiarDatosColegio: confirmadasOps.limpiarDatosColegio,
  aplicarFiltros: confirmadasOps.aplicarFiltros,
  resetFiltros: confirmadasOps.resetFiltros,
  borrarInscripcion: confirmadasOps.borrarInscripcion,
  cambiarFormaDePago: confirmadasOps.cambiarFormaDePago,
  resetSavedData: confirmadasOps.resetSavedData
};

export default connect(mapStateToProps, mapDispatchToProps)(ListaInscripciones);



// WEBPACK FOOTER //
// ./src/pages/inscripcionesConfirmadas/ListaInscripciones.jsx